<template>
  <div>
    <el-dialog title="凸凸虾内团系统" :visible="dialogInner" width="300px" @close="cancel">
      <div class="item">
        <el-input v-model="account" placeholder="请输入内团账号">
          <i slot="prefix" style="color: #5adfab;" class="el-input__icon el-icon-user"></i>
        </el-input>
      </div>
      <div class="item">
        <el-input v-model="pwd" type="password" placeholder="请输入内团密码">
          <i slot="prefix" style="color: #5adfab;" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-checkbox-group v-model="checkList" @change="changeRember">
          <el-checkbox label="记住账号密码"></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="btn" @click="login">登录</div>

    </el-dialog>
  </div>
</template>

<script>
  import {
    innerLogin
  } from "@/api/login";
  export default {
    data() {
      return {
        account: '',
        pwd: '',
        checkList: [],

      }
    },
    props: {
      dialogInner: {
        default: false
      }
    },
    mounted() {
      let remember = localStorage.getItem('rememberInner')
      if (remember == 'true') {
        this.account = localStorage.getItem('rememberAccount')
        this.pwd = localStorage.getItem('rememberPwd')
        this.checkList = ['记住账号密码']
      } else {
        this.checkList = []
      }
    },
    methods: {
      cancel() {
        this.$emit('update:dialogInner', false)
        if (this.$router.currentRoute.name == 'backRecored') {
          this.$router.back()
        }

      },
      changeRember(v) {
        if (v.length > 0) {
          localStorage.setItem('rememberInner', true)
        } else {
          localStorage.setItem('rememberInner', false)
        }
      },
      login() {
        if (this.checkList.length > 0) {
          localStorage.setItem('rememberAccount', this.account)
          localStorage.setItem('rememberPwd', this.pwd)
        } else {
          localStorage.removeItem('rememberAccount')
          localStorage.removeItem('rememberPwd')
        }
        if (!this.account) {
          this.$message({
            message: '请输入账号',
            type: 'warning'
          });
          return
        }
        if (!this.pwd) {
          this.$message({
            message: '请输入密码',
            type: 'warning'
          });
          return
        }
        innerLogin({
          account: this.account,
          password: this.pwd
        }).then(res => {
          if (res.code === 200) {
            localStorage.setItem('adminUser', JSON.stringify(res.data))
            this.$emit('success')
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .item {
    display: flex;
    margin-top: 15px;
    font-size: 15px;
    background-color: #F3F6F5;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    border-radius: 5px;

    /deep/ .el-input__inner {
      background-color: #F3F6F5;
      border: none;
    }
  }

  .btn {
    color: white;
    font-size: 15px;
    background-color: #5adfab;
    width: 260px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 40px;
    margin-top: 15px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/component/login.vue